/* eslint-disable keyword-spacing */
import React from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { route } from 'src/routing/navigation';
import styled from 'styled-components';
import LytButton from 'src/components/library/button/LytButton';
import { sessionAccessSelector } from 'src/routes/auth/auth.selectors';
import { bookList } from 'src/constants/bookList';
import { getDefaultRoute } from 'src/constants/routes.config';
import { FormattedMessage } from 'react-intl';
import { useViewLog } from 'src/hooks/useViewLog';
import { VIEW_NAME } from 'src/logger/view-events';

const CODE_LOCATION = 'src/routes/404/404.jsx';

const NotFoundContainer = styled.div`
    height: 100%;
    display: flex;
    align-items: center;
`;

const InnerContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
`;

const Content = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    max-width: 600px;
    padding: 0 20px;
`;

const Title = styled.h1`
    margin-bottom: 15px;
    font-size: 65px;
    line-height: 68px;
    font-weight: 700;
    text-align: center;
`;

const Description = styled.p`
    margin-bottom: 20px;
    font-size: 21px;
    line-height: 28px;
    font-weight: 400;
    text-align: center;
`;

const ButtonWrapper = styled.div`
    min-width: 200px;
    display: flex;
    justify-content: center;
`;

const NotFound = () => {
    const { pathname } = useLocation();
    const access = useSelector(sessionAccessSelector);
    const browserUrl = typeof window !== 'undefined'
        ? `${window.location.origin}${pathname}`
        : pathname;

    useViewLog({
        codeLocation: CODE_LOCATION,
        methodName: 'NotFound',
        route: bookList.notFound,
        viewName: VIEW_NAME.NOT_FOUND,
        attributes: {
            attempted_pathname: pathname,
            browser_url: browserUrl,
        },
    });

    const handleBackButtonClick = () => {
        if (access) {
            route(getDefaultRoute());
        } else {
            route(bookList.auth.login);
        }
    };

    return (
        <NotFoundContainer>
            <InnerContainer>
                <Content>
                    <Title>{<FormattedMessage id="PAGE_NOT_FOUND" />}</Title>
                    <Description>
                        {<FormattedMessage id="PAGE_NOT_FOUND_DESCRIPTION" />}
                    </Description>
                    <ButtonWrapper>
                        <LytButton
                            type="primary"
                            onClick={handleBackButtonClick}
                        >
                            <FormattedMessage id="BACK_TO_WEBSITE" />
                        </LytButton>
                    </ButtonWrapper>
                </Content>
            </InnerContainer>
        </NotFoundContainer>
    );
};

export default NotFound;
